import {
  GET_LIST_QUANLYTHUCHINGOAILE,
  GET_LIST_QUANLYTHUCHINGOAILE_SUCCESS,
  GET_LIST_QUANLYTHUCHINGOAILE_FAILURE,
} from "../../actions/QuanLyThuChiNgoaiLe/actionTypes";

const initialState = {
  List: [],
  TotalQuantity: 0,
  TotalTienThu: 0,
  TotalTienChi: 0,
  TotalThuKhac: 0,
  getListQuanLyThuChiNgoaiLeLoading: false,
};
const getListQuanLyThuChiNgoaiLe = (state, action) => ({
  ...state,
  getListQuanLyThuChiNgoaiLeLoading: true,
});

const getListQuanLyThuChiNgoaiLeSuccess = (state, action) => {
  // console.log(action);
  return {
    ...state,
    List: action.payload.List,
    TotalQuantity: action.payload.TotalQuantity,
    TotalTienThu: action.payload.TotalTienThu,
    TotalTienChi: action.payload.TotalTienChi,
    TotalThuKhac: action.payload.TotalThuKhac,
    getListQuanLyThuChiNgoaiLeLoading: false,
  };
};

const getListQuanLyThuChiNgoaiLeFailed = (state, action) => ({
  ...state,
  getListQuanLyThuChiNgoaiLeLoading: false,
  List: [],
});
export const listQuanLyThuChiNgoaiLeReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GET_LIST_QUANLYTHUCHINGOAILE:
      return getListQuanLyThuChiNgoaiLe(state, action);
    case GET_LIST_QUANLYTHUCHINGOAILE_SUCCESS:
      // alert("tuty");
      return getListQuanLyThuChiNgoaiLeSuccess(state, action);
    case GET_LIST_QUANLYTHUCHINGOAILE_FAILURE:
      //alert('false')
      return getListQuanLyThuChiNgoaiLeFailed(state, action);
    default:
      return state;
  }
};

export default listQuanLyThuChiNgoaiLeReducer;
